import Vue from "vue";
import { Validator } from "vee-validate";
//import moment from 'moment'
export const EventBus = new Vue();

import moment from "moment";
import VueMomentJS from "vue-momentjs";
Vue.use(VueMomentJS, moment);

import axios from 'axios'


const assistantID = "asst_uaH1CqPjZSD9YicM4arnblmW";
const API_URL = "https://api.openai.com/v1"
const aiAxios = axios.create({
  baseURL: API_URL,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'Authorization': `Bearer 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`,
    'OpenAI-Beta': 'assistants=v2'
  }
})
const qs = require('qs');
export const tenantId = process.env.TENANT_ID;
export const clientId = process.env.CLIENT_ID;
export const clientSecret = process.env.CLIENT_SECRET;
export const workspaceId = process.env.WORKSPACE_ID;
export const reportId = process.env.REPORT_ID;

const azureAxios = axios.create({
  baseURL: `https://login.microsoftonline.com/8a4b8250-f491-487c-80a7-e4146f877233`,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
  },
})


Vue.mixin({
  data() {
    return {
      button_loading: false,
      current_locale: "en",
      limitarr: [
        { text: "5", value: 5 },
        { text: "10", value: 10 },
        { text: "25", value: 25 },
        { text: "50", value: 50 },
        { text: "100", value: 100 },
        { text: "200", value: 200 },
      ],
    };
  },

  created() {
    if (this.$store) {
      this.axios.defaults.headers.common["Authorization"] =
        "Bearer " + this.$store.state.authToken;
    }
  },
  methods: {
    focusTextField() {
      setTimeout(() => {
        document.getElementById("textName").focus();
      }, 100);
    },
    exportFile(data, filename) {
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename + ".csv");
      document.body.appendChild(link);
      link.click();
      return;
    },
    exportPdfFile(data, filename) {
      const url = window.URL.createObjectURL(
        new Blob([data], { type: "application/pdf" })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename + ".pdf");
      document.body.appendChild(link);
      link.click();
      return;
    },
    downloadZipFile(data, filename) {
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename + ".zip");
      document.body.appendChild(link);
      link.click();
      return;
    },
    downloadIMG(imageURL) {
      const fileName = imageURL.split("/").pop().split("?")[0];
      const link = document.createElement("a");
      link.href = imageURL;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
    },
    downloadZipApp(data, filename) {
      // const url = window.URL.createObjectURL(
      //   new Blob([data])
      // );
      const link = document.createElement("a");
      link.href = data;
      link.setAttribute("download", filename + ".zip");
      document.body.appendChild(link);
      link.click();
      return;
    },
    exportExcelFile(data, filename) {
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename + ".xlsx");
      document.body.appendChild(link);
      link.click();
      return;
    },
    setValidationMessage() {
      let dict = {
        custom: {
          email: {
            required: this.$t("validations.enter_email"),
            email: this.$t("validations.enter_valid_email"),
          },
          password: {
            required: this.$t("validations.enter_password"),
            min: this.$t("validations.password_validation"),
          },
          password_confirmation: {
            required: this.$t("validations.enter_confirm_password"),
            confirmed: this.$t("validations.confirm_password_validation"),
          },
          old_password: {
            required: this.$t("validations.enter_old_password"),
          },
          new_password: {
            required: this.$t("validations.enter_new_password"),
            min: this.$t("validations.password_validation"),
          },
          password_recovery: {
            required: this.$t("validations.enter_recovery_password"),
          },
          name: {
            max: this.$t("validations.name_limit"),
            required: this.$t("validations.name"),
          },
          org_name: {
            max: this.$t("validations.name_limit"),
            required: this.$t("validations.org_name"),
          },
          role_validation: {
            required: this.$t("validations.role_validation"),
          },
          role_description: {
            required: this.$t("validations.role_description"),
          },
          contact_name: {
            required: this.$t("validations.contact_name"),
          },
          phone: {
            numeric: this.$t("validations.enter_digit"),
            required: this.$t("validations.phone"),
          },
          imo_number: {
            alpha_num: this.$t("validations.imo_number"),
            required: this.$t("validations.enter_imo_number"),
          },
          service_requirement: {
            required: this.$t("validations.service_requirement"),
          },
          port_detail: {
            required: this.$t("validations.port_detail"),
          },
          agent_detail: {
            required: this.$t("validations.agent_detail"),
          },
          role: {
            required: this.$t("validations.role_id"),
          },
          owner: {
            required: this.$t("validations.select_owner"),
          },
          manager: {
            required: this.$t("validations.select_manager"),
          },
          office: {
            required: this.$t("validations.select_office"),
          },
          fleet: {
            required: this.$t("validations.select_fleet"),
          },
          subtype: {
            required: this.$t("validations.select_subtype"),
          },
          type: {
            required: this.$t("validations.select_type"),
          },
          country_name: {
            max: this.$t("validations.country_name_limit"),
            required: this.$t("validations.country_name"),
            alpha_spaces: this.$t("validations.country_alpha_spaces"),
          },
          iso_code: {
            required: this.$t("validations.iso_code"),
            length: this.$t("validations.iso_code_length"),
          },
          country: {
            required: this.$t("validations.select_country"),
          },
          port: {
            required: this.$t("validations.select_port"),
          },
          vessel_name: {
            required: this.$t("validations.enter_vessel_name"),
          },
          port_name: {
            required: this.$t("validations.enter_port_name"),
          },
          section_name: {
            required: this.$t("validations.enter_section_name"),
          },
          subsection_name: {
            required: this.$t("validations.enter_subsection_name"),
          },
          service_name: {
            required: this.$t("validations.enter_service_name"),
          },
          designation_name: {
            required: this.$t("validations.enter_designation_name"),
          },
          risk_factor_name: {
            required: this.$t("validations.enter_riskfactor_name"),
          },
          number: {
            numeric: this.$t("validations.question_number_only"),
            max: this.$t("validations.question_number"),
            required: this.$t("validations.enter_question_number"),
          },
          section: {
            required: this.$t("validations.select_section"),
          },
          sub_section: {
            required: this.$t("validations.select_subsection"),
          },
          designation: {
            required: this.$t("validations.select_designation"),
          },
          question_name: {
            required: this.$t("validations.enter_question_name"),
          },
          vesselType: {
            required: this.$t("validations.select_vessel_type"),
          },
          vesselTypes: {
            required: this.$t("validations.select_vessel_type"),
          },
          vessel_subtype: {
            required: this.$t("validations.select_vessel_subtype"),
          },
          flag: {
            required: this.$t("validations.select_flag"),
          },
          select_designations: {
            required: this.$t("validations.select_designation"),
          },
          active_date: {
            required: this.$t("validations.select_active_date"),
          },
          deactive_date: {
            required: this.$t("validations.select_deactive_date"),
          },
          regulation_reference: {
            required: this.$t("validations.enter_regulation_reference"),
          },
          specific_guidance: {
            required: this.$t("validations.enter_guidance_message"),
          },
          flag_guidance: {
            required: this.$t("validations.enter_guidance_message"),
          },
          vessel_guidance: {
            required: this.$t("validations.enter_guidance_message"),
          },
          sub_type_: {
            required: this.$t("validations.enter_guidance_message"),
          },
          hazard_name: {
            required: this.$t("validations.enter_hazard"),
          },
          preventative_barrier_name: {
            required: this.$t("validations.enter_preventative_barrier"),
          },
          topevent_name: {
            required: this.$t("validations.enter_topevent"),
          },
          threat_name: {
            required: this.$t("validations.enter_threat"),
          },
          mitigating_barrier_name: {
            required: this.$t("validations.enter_mitigating_barrier"),
          },
          consequence_name: {
            required: this.$t("validations.enter_consequence"),
          },
          escalation_factor_name: {
            required: this.$t("validations.enter_escalation_factor"),
          },
          escalation_factor_barrier_name: {
            required: this.$t("validations.enter_escalation_factor_barrier"),
          },
          escalation_barrier: {
            required: this.$t("validations.select_escalation_barrier"),
          },
          mitigating_barrier: {
            required: this.$t("validations.select_mitigating_barrier"),
          },
          image_upload: {
            required: this.$t("validations.select_image"),
          },
          work_instructions: {
            required: this.$t("validations.enter_work_instructions"),
          },
          project_name: {
            required: this.$t("validations.enter_project_name"),
          },
          vessel: {
            required: this.$t("validations.select_vessel"),
          },
          reviewer: {
            required: this.$t("validations.select_reviewer"),
          },
          services: {
            required: this.$t("validations.select_services"),
          },
          consultants: {
            required: this.$t("validations.select_consultants"),
          },
          date: {
            required: this.$t("validations.select_date"),
          },
          defect_name: {
            required: this.$t("validations.enter_defect"),
          },
          code: {
            required: this.$t("validations.enter_code"),
          },
          description: {
            required: this.$t("validations.enter_description"),
          },
          url: {
            required: this.$t("validations.choose_image"),
          },
          date_of_birth: {
            required: this.$t("validations.select_date_of_birth"),
          },
          place_of_birth: {
            required: this.$t("validations.select_place_of_birth"),
          },
          nationality: {
            required: this.$t("validations.select_nationality"),
          },
          street1: {
            required: this.$t("validations.enter_street1"),
          },
          street2: {
            required: this.$t("validations.enter_street2"),
          },
          city: {
            required: this.$t("validations.enter_city"),
          },
          postal_code: {
            required: this.$t("validations.enter_postal_code"),
          },
          rank: {
            required: this.$t("validations.enter_rank"),
          },
          date_of_joining: {
            required: this.$t("validations.select_date_of_joining"),
          },
          work_mobile_number: {
            required: this.$t("validations.enter_work_mobile_number"),
          },
          home_telephone_number: {
            required: this.$t("validations.enter_home_telephone_number"),
          },
          home_email_address: {
            required: this.$t("validations.enter_home_email_address"),
          },
          mobile_number: {
            required: this.$t("validations.enter_mobile_number"),
          },
          issuing_authority: {
            required: this.$t("validations.issuing_authority"),
          },
          num: {
            required: this.$t("validations.num"),
          },
          issue_date: {
            required: this.$t("validations.issue_date"),
          },
          expiry_date: {
            required: this.$t("validations.expiry_date"),
          },
          select_number: {
            required: this.$t("validations.select_number"),
          },
        },
      };
      Validator.localize("en", dict);
    },
    button_loader(val, container) {
      this.button_loading = val;
      if (val) {
        this.$vs.loading({
          background: "primary",
          color: "#fff",
          container: container,
          scale: 0.45,
        });
      } else {
        this.$vs.loading.close(container + " > .con-vs-loading");
      }
    },
    async logout() {
      let response = await this.getHTTPPostResponse("/logout");
      this.clearUserInfo();
    },
    clearUserInfo() {
      localStorage.removeItem("authToken");
      localStorage.removeItem("user");
      localStorage.removeItem("limit");
      // go to base url (right now login screen)
      location.href = process.env.BASE_URL;
    },
    showError(e, button_loader = null) {
      button_loader
        ? this.button_loader(false, button_loader)
        : this.$vs.loading.close();

      // if user is unauthorised, clear user info
      if (e.response.status === 401) {
        setTimeout(() => {
          this.clearUserInfo();
        }, 1000);
      }

      if (!e.response || !e.response.data || !e.response.data.message) {
        return;
      }
      let error = e.response.data.message;
      this.$vs.notify({
        title: "Error.",
        text: error,
        color: "danger",
        position: "top-right",
      });
    },
    async getHTTPPostResponse(
      url,
      input = {},
      button_loader = null,
      success_message = false
    ) {
      if (button_loader) this.button_loader(true, button_loader);
      const data = await this.axios
        .post(url, input)
        .then((response) => {
          let data = response.data;
          if (button_loader) this.button_loader(false, button_loader);
          if (data.status != "200") {
            this.showError({ response }, button_loader);
          } else if (success_message) {
            this.$vs.notify({
              title: "Success.",
              text: data.message,
              color: "success",
              position: "top-right",
            });
          }
          return data;
        })
        .catch((e) => {
          this.showError(e, button_loader);
          return null;
        });
      return data;
    },
    async getHTTPPutResponse(
      url,
      input = {},
      button_loader = null,
      success_message = false
    ) {
      if (button_loader) this.button_loader(true, button_loader);
      const data = await this.axios
        .put(url, input)
        .then((response) => {
          let data = response.data;
          if (button_loader) this.button_loader(false, button_loader);
          if (data.status != "200") {
            this.showError({ response }, button_loader);
          } else if (success_message) {
            this.$vs.notify({
              title: "Success.",
              text: data.message,
              color: "success",
              position: "top-right",
            });
          }
          return data;
        })
        .catch((e) => {
          this.showError(e, button_loader);
          return null;
        });
      return data;
    },
    async getHTTPDeleteResponse(
      url,
      button_loader = null,
      success_message = false
    ) {
      if (button_loader) this.button_loader(true, button_loader);
      const data = await this.axios
        .delete(url)
        .then((response) => {
          let data = response.data;
          if (button_loader) this.button_loader(false, button_loader);
          if (response.status != "200") {
            this.showError({ response }, button_loader);
          } else if (success_message) {
            this.$vs.notify({
              title: "Success.",
              text: data.message,
              color: "success",
              position: "top-right",
            });
          }
          return data;
        })
        .catch((e) => {
          this.showError(e, button_loader);
          return null;
        });
      return data;
    },
    async getHTTPGetResponse(
      url,
      button_loader = null,
      success_message = false
    ) {
      if (button_loader) this.button_loader(true, button_loader);
      const data = await this.axios
        .get(url)
        .then((response) => {
          let data = response.data;
          if (button_loader) this.button_loader(false, button_loader);
          if (response.status != "200" || response.data.status != '200') {
            this.showError({ response }, button_loader);
          } else if (success_message) {
            this.$vs.notify({
              title: "Success.",
              text: data.message,
              color: "success",
              position: "top-right",
            });
          }
          return data;
        })
        .catch((e) => {
          this.showError(e, button_loader);
          return null;
        });
      return data;
    },
    checkPermission(code, access) {
      let permissions = this.$store.state.permissions;
      let permission = permissions.find(
        (permission) => permission.code === code
      );
      if (!permission) return false;

      switch (access) {
        case "add":
          return permission.add;

        case "modify":
          return permission.modify;

        case "delete":
          return permission.delete;

        case "view":
          return permission.view;

        default:
          break;
      }
    },
    isUserType(type) {
      return this.$store.state.userInfo.type === type;
    },
    displayError(e) {
      let error = e;
      this.$vs.notify({
        title: "Error.",
        text: error,
        color: "danger",
        position: "top-right",
      });
    },
    async aiReportAnalyst(file) {
      const formData = new FormData();
      formData.append('purpose', 'assistants');
      formData.append('file', file);
      const fileRes = await aiAxios.post('/files', formData);
      if (!fileRes.data) {
        this.$vs.loading.close();
        this.$vs.notify({
          text: 'File upload failed',
          color: "danger",
          position: "top-right",
        });
        return
      }
      const attachments = [
        {
          file_id: fileRes.data.id,
          tools: [{ type: "file_search" }]
        }
      ]
      const thread = await aiAxios.post('/threads');
      const threadId = thread.data.id;

      const threadMsg = await aiAxios.post(`/threads/${threadId}/messages`, { role: "user", content: "Analyze given ship inspection report and generate required json format.", attachments });

      const run = await aiAxios.post(`/threads/${threadId}/runs`, { assistant_id: assistantID })

      const runId = run.data.id;
      const runStatus = await this.startIntervalAndWait(threadId, runId);

      if (runStatus.data.status === 'completed') {

        const runMessages = await aiAxios.get(`/threads/${threadId}/messages`);

        const deleteFile = await aiAxios.delete(`/files/${fileRes.data.id}`)
        return runMessages
      } else {
        this.$vs.loading.close();
        this.$vs.notify({
          text: 'File analysis failed',
          color: "danger",
          position: "top-right",
        });
        return null;
      }

    },

    startIntervalAndWait(threadId, runId) {
      return new Promise((resolve, reject) => {
        const intervalId = setInterval(async () => {
          const res = await aiAxios.get(`/threads/${threadId}/runs/${runId}`);
          if (res && res.data.last_error) {
            clearInterval(intervalId);
            reject(res.data.last_error);
          }
          if (res && res.data.status === 'completed') {
            clearInterval(intervalId);
            resolve(res);
          }
        }, 3000);
      });
    },
    async getAzureAccessToken() {
      // const tokenUrl = `${authority}/oauth2/v2.0/token`;
      const params = {
        grant_type: 'client_credentials',
        client_id: '10347dec-f6aa-440a-bad6-995266dce1c8',
        client_secret: 'e5297518-377e-41df-8cb0-9fa5e92bdc4e',
        scope: 'https://analysis.windows.net/powerbi/api/.default',
      };

      try {
        const response = await azureAxios.post('/oauth2/v2.0/token', qs.stringify(params), {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        });
        return response.data.access_token;
      } catch (error) {
        console.error('Error fetching access token:', error);
        throw error;
      }
    }
  },

  filters: {
    k_formatter(num) {
      return num > 999 ? (num / 1000).toFixed(1) + "k" : num;
    },
    capitalize(value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
    date_format(date) {
      if (!date) return "-";
      // return moment.utc(date).local().format("DD/MMM/YYYY HH:mm");
      return moment.utc(date).local().format("DD MMM YYYY HH:mm");
    },
    only_date_format(date) {
      if (!date) return "-";
      // return moment
      //   .utc(date)
      //   .local()
      //   .format("DD/MMM/YYYY");
      return moment.utc(date).local().format("DD MMM YYYY");
    },
    getDateOnly(value) {
      if (!value) return "";
      value = Date.split("");
      return value[0];
    },
    getUserType(value) {
      let text = "";
      // let _this = this
      switch (value) {
        case "A":
          //text =  _this.$t('labels.admin');
          text = "Admin";
          break;

        case "CL":
          //text =  _this.$t('labels.client');
          text = "Client";
          break;

        case "CN":
          //text =  _this.$t('labels.consultant');
          text = "Consultant";
          break;

        default:
          break;
      }
      return text;
    },
    getUserSubType(value) {
      let text = "";
      switch (value) {
        case "OW":
          //text =  this.$t('labels.owner');
          text = "Owner";
          break;

        case "M":
          //text =  this.$t('labels.manager');
          text = "Manager";
          break;

        case "OF":
          //text =  this.$t('labels.office');
          text = "Office";
          break;

        case "F":
          //text =  this.$t('labels.fleet');
          text = "Fleet";
          break;

        default:
          break;
      }
      return text;
    },
    nameString(value) {
      return value.map((v) => v.name).join(", ");
    },
  },
});
